import {PhysicRelation} from "../../GamePhysicsModel";
import {ObjectModel} from "../../ObjectModel";
import {ModelCollection} from "../../ModelCollection";
import {Vector2, Vector2I} from "../../../../tools/data/Vector2";
import {GraphicEffectModel} from "../../GraphicEffectModel";

export interface EffectDefinition {
    base_damage: number;
    base_force: number;
    effect_radius: number;
}

export class DamageInteractionHelper {
    public static calculate_force(effect_defintion: EffectDefinition, hit_object: ObjectModel, relation: PhysicRelation, source: ObjectModel): number {
        const real_distance = relation.distance - hit_object.collision_radius - source.collision_radius;
        const real_max_distance = effect_defintion.effect_radius + hit_object.collision_radius + source.collision_radius;
        const damage_mod = (750000 + hit_object.damage * hit_object.damage) / 1750000;
        const distance_mod = Math.min(1, Math.max(0.5, 1 - real_distance / real_max_distance));
        const weight_mod = 1 / hit_object.weight;
        const force = effect_defintion.base_force * damage_mod * distance_mod * weight_mod;
        return force;
    }

    public static calculate_damage(effect_defintion: EffectDefinition, hit_object: ObjectModel, relation: PhysicRelation, source: ObjectModel): number {
        const real_distance = relation.distance - hit_object.collision_radius - source.collision_radius;
        const damage_modifier = 1 - real_distance / effect_defintion.effect_radius;
        const clamped_modifier = Math.max(1, Math.min(0.5, damage_modifier));
        const damage = effect_defintion.base_damage * clamped_modifier;
        return damage;
    }

    public static apply_effects_to_objects_hit(
        source: ObjectModel,
        effect_definition: EffectDefinition,
        models: ModelCollection,
        force_direction?: Vector2I,
    ) {
        models.objects.map((object) => {
            if (object === source) return object;
            const relation = source.caching_physics_relation.get(object);
            if (!relation) return object;
            const real_radius = effect_definition.effect_radius + source.collision_radius + object.collision_radius;
            const direction = object.physics.get_left_vector().dot(relation.position_difference);
            const is_in_looking_direction = ((direction > 0) && source.looking_left) || ((direction < 0) && !source.looking_left);
            if (is_in_looking_direction && (relation.distance < real_radius)) {
                const damage = DamageInteractionHelper.calculate_damage(effect_definition, object, relation, source);
                object.damage = Math.min(999, object.damage + damage);

                const force = DamageInteractionHelper.calculate_force(effect_definition, object, relation, source);
                const direction = force_direction
                    ? new Vector2(force_direction).rotate_radians_clockwise(source.rotation)
                    : new Vector2(relation.position_difference).mul(1 / relation.distance);

                object.velocity.set(direction.mul(force));
                GraphicEffectModel.create_explosion(models.graphic_effects, object.position.cpy());
            }
            return object;
        });
    }

    public static damage_vector
}